import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import About from "../pages/About/About";
import Default from "../pages/Default/Default";
import Pricing from "../pages/Pricing/Pricing";
import Product from "../pages/Product/Product";
import ProductV2 from "../pages/Product/Product_v2";
import Terms from "../pages/Terms/Terms";
import VMSServices from "../pages/VMSServices/VMSServices";
import WeatherFactor from "../pages/WeatherFactor/WeatherFactor";
import WeatherInPort from "../pages/WeatherInPort/WeatherInPort";
import BunkerRoute from "../pages/BunkerRoute/BunkerRoute";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Main: React.FC = () => {
  const query = useQuery();
  const page = query.get("page");

  useEffect(() => {
    const pageName = page || "home";
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_title: pageName,
        page_location: window.location.href,
        page_path: `/?page=${pageName}`,
      });
    }
  }, [page]);

  return (
    <>
      {page === "about" && <About />}
      {page === "terms" && <Terms />}
      {page === "product" && <ProductV2 />}
      {page === "product-old" && <Product />}
      {page === "vmsservices" && <VMSServices />}
      {page === "price" && <Pricing />}
      {page === "wf" && <WeatherFactor />}
      {page === "weatherinport" && <WeatherInPort />}
      {page === "bunker" && <BunkerRoute />}
      {!page && <Default />}
    </>
  );
};

export default Main;